module.exports = __webpack_public_path__ + "static/2-f041f9340e0d696e66515db439d7c746.png";